import { Box, IconButton, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import ClearIcon from '@mui/icons-material/Clear'
import { makeStyles } from 'tss-react/mui'
import { useDebounce } from '@e3dc-react/shell/Hooks/useDebounce'
import { PRODUCT_CART_DEBOUNCE_TIMER } from '../../consts'
import ButtonQuantity from '../ShopProduct/ButtonQuantity'

interface ShopRetrofitBatteryExistingSingleProductProps {
  batteryQuantity: number
  serialNumber: string | undefined
  maxQuantity: number
  minQuantity: number
  batteryId: string
  onBatteryChangeQuantity: (productId: string, quantity: number) => void
  onBatteryDelete: (productId: string) => void
}

const useStyles = makeStyles()(theme => ({
  fieldContainer: {
    marginTop: theme.spacing(2),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  numCounter: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    transform: 'translateX(20px)',
  },
}))

/*
 * This component is used to show all the existing retrofit batteries that are already on cart.
 * It also allow the user to update quantity or remove the battery from cart. Serial number cannot be changed
 */
const ShopRetrofitBatteryExistingSingleProduct: React.FC<ShopRetrofitBatteryExistingSingleProductProps> = ({
  batteryQuantity,
  serialNumber,
  maxQuantity,
  batteryId,
  minQuantity,
  onBatteryChangeQuantity,
  onBatteryDelete,
}) => {
  const [quantity, setQuantity] = useState<number>(batteryQuantity)
  const { classes } = useStyles()
  const debouncedQuantity = useDebounce(quantity, PRODUCT_CART_DEBOUNCE_TIMER)

  useEffect(() => {
    if (debouncedQuantity !== batteryQuantity) {
      onBatteryChangeQuantity(batteryId, debouncedQuantity)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [debouncedQuantity])

  return (
    <Box className={classes.fieldContainer}>
      <TextField disabled={true} fullWidth value={serialNumber} />
      <Box className={classes.numCounter}>
        <ButtonQuantity
          quantity={quantity}
          onQuantityDecrease={() => {
            setQuantity(quantity - 1)
          }}
          onQuantityIncrease={() => {
            setQuantity(quantity + 1)
          }}
          onQuantityChange={quantity => setQuantity(quantity)}
          maxQuantity={maxQuantity}
          minQuantity={minQuantity}
        />
        <IconButton
          onClick={() => {
            onBatteryDelete(batteryId)
          }}
        >
          <ClearIcon />
        </IconButton>
      </Box>
    </Box>
  )
}

export default ShopRetrofitBatteryExistingSingleProduct
